import { CompanyAddEditForm } from '@/components/form/CompanyAddEditForm'

export const CompanyCreateEdit = ({ actionType }: { actionType: "create" | "edit" }) => {
  return (
    <CompanyAddEditForm actionType={actionType} />
  )
}